import { createAction, createReducer } from 'redux-act';
import { API_INSTANCE } from '../../utils/service-http';
import { api_base_url } from '../../constants';

/**
 * Reducer and action used to create or validate a session
 */
const DEFAULT_SESSION_STATE = { isLoading: true, error: null };

export const createSessionStarted = createAction('CREATE_MSX_SESSION_STARTED');
export const createSessionSuccess = createAction('CREATE_MSX_SESSION_SUCCESS');
export const createSessionFailed = createAction('CREATE_MSX_SESSION_FAILED');

export const createSessionReducer = createReducer(function (on, off) {
  on(createSessionStarted, (state, payload) => {
    return { isLoading: true, error: null };
  });
  on(createSessionSuccess, (state, payload) => {
    return { isLoading: false, error: null };
  });
  on(createSessionFailed, (state, payload) => {
    return { isLoading: false, error: null };
  });

}, DEFAULT_SESSION_STATE);


export function createSession() {
  return async dispatch => {
    dispatch(createSessionStarted());
    return API_INSTANCE.get(api_base_url + `/sessions?t=${new Date().getTime()}`)
      .then((success) => {
        dispatch(createSessionSuccess());
        return success.data.payload;
      }).catch((error) => {
        dispatch(createSessionFailed());
        throw error;
      });
  }
}




